import RadioCardListPage from "@components/RadioCardListPage"
import {
  addTryFirstToLocalStorage,
  getIsFemaleFromLocalStorage,
} from "@helpers/localStorage"

const KEY_TO_STORAGE: Record<string, string> = {
  faceAnalysis: "looksmaxxing",
}

export default function TryFirstPage() {
  const isFemale = getIsFemaleFromLocalStorage()

  const OPTIONS = [
    {
      emoji: isFemale
        ? "\uD83D\uDC87\u200D\u2640\uFE0F"
        : "\uD83D\uDC87\u200D\u2642\uFE0F",
      key: "hairstyle",
    },
    { emoji: "\uD83D\uDD2C", key: "faceAnalysis" },
    { emoji: "\uD83D\uDD8C\uFE0F", key: "photoEditing" },
    { emoji: "🏠", key: "homeDesign" },
    {
      emoji: isFemale
        ? "\uD83D\uDC69\u200D\uD83D\uDCBC"
        : "\uD83D\uDC68\u200D\uD83D\uDCBC",
      key: "professional",
    },
    { emoji: "\uD83D\uDCF8", key: "studioModelling" },
    { emoji: "\uD83D\uDC57", key: "newOutfits" },
    { emoji: "\uD83D\uDC3E", key: "petPortraits" },
    { emoji: "\uD83C\uDFA8", key: "cartoonFilters" },
    { emoji: "\u2B50", key: "celebrity" },
    { emoji: "\uD83C\uDFAD", key: "creative" },
    { emoji: "\uD83D\uDCAB", key: "other" },
  ]

  const handleBeforeSubmit = (_value: string, key: string) => {
    addTryFirstToLocalStorage(KEY_TO_STORAGE[key] ?? key)
  }

  return (
    <RadioCardListPage
      translationKey="tryFirstV2"
      options={OPTIONS}
      onBeforeSubmit={handleBeforeSubmit}
    />
  )
}
